module.exports = __webpack_public_path__ + "static/story8-a7b14a74cff1b5b044cb73bebbecb033.png";